import { useState } from "react"

import { Text, useDisclosure } from "@chakra-ui/react"

import Alert from "components/alert/Alert"

import { ShowPropsType } from "./types"

const useAlertHook = (): [
  React.ReactNode,
  ({ pbText, sbText }: ShowPropsType) => void,
  () => void,
  React.Dispatch<React.SetStateAction<boolean>>,
] => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const [alertMessage, setAlertMessage] = useState("")
  const [isPrimaryActionLoading, setIsPrimaryActionLoading] = useState(false)
  const [primaryButtonText, setPrimaryButtonText] = useState("")
  const [secondaryButtonText, setSecondaryButtonText] = useState("Cancel")
  const [primaryButtonOnClickAction, setPrimaryButtonOnClickAction] = useState(
    () => () => {},
  )
  const [secondaryButtonOnClickAction, setSecondaryButtonOnClickAction] =
    useState(() => () => {})

  const showAlert = ({
    message,
    pbText,
    sbText,
    pbOnClick,
    sbOnClick,
  }: ShowPropsType) => {
    setAlertMessage(message)
    setPrimaryButtonText(pbText)
    setSecondaryButtonText(sbText)
    setPrimaryButtonOnClickAction(pbOnClick)
    setSecondaryButtonOnClickAction(sbOnClick)
    onOpen()
  }

  const alert = (
    <Alert
      isOpen={isOpen}
      onClose={secondaryButtonOnClickAction}
      primaryButtonText={primaryButtonText}
      secondaryButtonText={secondaryButtonText}
      primaryButtonOnClick={primaryButtonOnClickAction}
      secondaryButtonOnClick={secondaryButtonOnClickAction}
      isPrimaryActionLoading={isPrimaryActionLoading}
    >
      <Text
        alignSelf='center'
        variant='gray'
        size='lg'
        fontWeight='600'
        px='30px'
      >
        {alertMessage}
      </Text>
    </Alert>
  )
  return [alert, showAlert, onClose, setIsPrimaryActionLoading]
}

export default useAlertHook
